import { render } from "./SelectionGoods.vue?vue&type=template&id=7a5e9e16&scoped=true"
import script from "./SelectionGoods.vue?vue&type=script&lang=js"
export * from "./SelectionGoods.vue?vue&type=script&lang=js"

import "./SelectionGoods.vue?vue&type=style&index=0&id=7a5e9e16&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5e9e16"]])

export default __exports__